export function mobileNav() {
    const body = $("body");
    $(".btn-menu").on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js